import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PedidoItemDescontoMaximoExcedidoTableComponent } from './pedido-item-desconto-maximo-excedido-table.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoItemDescontoMaximoExcedidoTableComponent
    ],
    exports: [
        PedidoItemDescontoMaximoExcedidoTableComponent
    ]
})
export class PedidoItemDescontoMaximoExcedidoTableModule { }
